import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function TafsailReportPrint(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={12} docNamePdf={"DetailsReport.pdf"} docName={"DetailsReport"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
